import { PortalRequest as request } from "@/utils/request";

export const getConsultList = (pageParams, data) => {
  return request({
    url: "/consult/page-list",
    method: "post",
    params: pageParams,
    data,
  });
};

export const getEvaluationConsultList = (pageParams, data) => {
  return request({
    url: "/evaluation-consult/page-list",
    method: "post",
    params: pageParams,
    data,
  });
};

export const evaluationConsultSave = (data) => {
  return request({
    url: "/evaluation-consult/save",
    method: "post",
    data,
  });
};

export const evaluationConsultRemove = (id) => {
  return request({
    url: `/evaluation-consult/remove/${id}`,
    method: "delete",
  });
};

export const getEvaluationConsultInfo = (id) => {
  return request({
    url: `/evaluation-consult/info/${id}`,
    method: "get",
  });
};

/**
 * 元服务咨询_元服务咨询表分页查询
 * @param pageParams
 * @param data
 * @returns {AxiosPromise}
 */
export const getServiceConsultList = (pageParams, data) => {
  return request({
    url: "/service-consult/page-list",
    method: "post",
    params: pageParams,
    data,
  });
};

/**
 * 元服务咨询_元服务咨询表保存
 * @param data
 * @returns {AxiosPromise}
 */
export const serviceConsultSave = (data) => {
  return request({
    url: "/service-consult/save",
    method: "post",
    data,
  });
};

/**
 * 元服务咨询_元服务咨询提交申请
 * @param data
 * @returns {AxiosPromise}
 */
export const serviceConsultCommit = (data) => {
  return request({
    url: "/service-consult/apply-commit",
    method: "post",
    data,
  });
};

/**
 * 元服务咨询_获取父id为null的分类列表
 * @returns {AxiosPromise}
 */
export const typeListByPidIsNull = () => {
  return request({
    url: `/service-consult-type/get-type-list-by-pid-is-null`,
    method: "get",
  });
};

/**
 * 元服务咨询_获取父id其下分类列表
 * @returns {AxiosPromise}
 */
export const typeListByPid = (pid) => {
  return request({
    url: `/service-consult-type/get-type-list-by-pid`,
    method: "get",
    params: { pid },
  });
};

/**
 * 元服务咨询_元服务咨询表详情
 * @param id
 * @returns {AxiosPromise}
 */
export const getServiceConsultInfo = (id) => {
  return request({
    url: `/service-consult/info/${id}`,
    method: "get",
  });
};

/**
 * 元服务咨询_对接日志详情分页查询
 * @param pageParams
 * @param data
 * @returns {AxiosPromise}
 */
export const getServiceConsultLogDetailList = (pageParams, data) => {
  return request({
    url: "/service-consult-detail/page-list",
    method: "post",
    params: pageParams,
    data,
  });
};

/**
 * 元服务咨询_对接日志详情保存
 * @param data
 * @returns {AxiosPromise}
 */
export const serviceConsultLogDetailSave = (data) => {
  return request({
    url: "/service-consult-detail/save",
    method: "post",
    data,
  });
};
